/**
 * Register the SociBaba service worker.
 * Skips registration in dev to avoid HMR conflicts.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Poll for updates roughly once an hour while the tab is open
        setInterval(() => reg.update().catch(() => null), 60 * 60 * 1000);
      })
      .catch(() => {
        /* silent — PWA install is progressive enhancement */
      });
  });
}

export function unregisterServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}
